import { render, staticRenderFns } from "./AdjustmentsModal.vue?vue&type=template&id=2bf8bc3b&"
import script from "./AdjustmentsModal.vue?vue&type=script&lang=js&"
export * from "./AdjustmentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports